export default "__VITE_ASSET__241355d0__"